import { useState } from 'react';

import classNames from 'classnames';
import { Search } from 'src/common/components';

import { AutoscalingView } from '../constants';

import { AccountList } from './components/AccountList';
import { ParentAccountList } from './components/ParentAccountList';

export const AutoScaling = (): JSX.Element => {
  const [view, setView] = useState(AutoscalingView.PARENT_ACCOUNTS);
  const [filter, setFilter] = useState('');

  return (
    <div className="flex flex-col p-8" style={{ height: 'calc(100vh - 66px)' }}>
      <div className="flex items-center pb-4">
        <h2 className="sm:px-0 flex-1">Manual scaling accounts</h2>
        <Search setSearch={setFilter} placeholder="Search..." className="max-w-sm ml-auto" />
        <span className="ring-1 ring-primary-2.0 ring-inset isolate inline-flex ml-4 rounded-md shadow-sm">
          <button
            onClick={() => setView(AutoscalingView.SIMPLE_ACCOUNTS)}
            type="button"
            className={classNames(
              'rounded-l-md hover:bg-gray-50 focus:z-10 relative inline-flex items-center px-3 py-2 text-sm font-semibold text-gray-900',
              view === AutoscalingView.SIMPLE_ACCOUNTS && 'bg-primary-2.0 text-white-0.0'
            )}
          >
            Accounts
          </button>
          <button
            onClick={() => setView(AutoscalingView.PARENT_ACCOUNTS)}
            type="button"
            className={classNames(
              'rounded-r-md hover:bg-gray-50 focus:z-10 relative inline-flex items-center px-3 py-2 text-sm font-semibold text-gray-900',
              view === AutoscalingView.PARENT_ACCOUNTS && 'bg-primary-2.0 text-white-0.0'
            )}
          >
            Parent accounts
          </button>
        </span>
      </div>
      <div className="flex flex-col flex-1 overflow-y-auto">
        {view === AutoscalingView.PARENT_ACCOUNTS && <ParentAccountList query={filter} />}
        {view === AutoscalingView.SIMPLE_ACCOUNTS && <AccountList query={filter} />}
      </div>
    </div>
  );
};
